import { isArray, isEmpty, isObject } from 'lodash';

const allObjectValuesAreEmpty = (obj: Record<string, any>): boolean => {
  return Object.values(obj).every((value) => {
    if (value === false || value === null || value === undefined) {
      return true;
    }
    if (isObject(value)) {
      return allObjectValuesAreEmpty(value);
    }
    if (isArray(value)) {
      return isEmpty(value);
    }
    return false;
  });
};

export { allObjectValuesAreEmpty };
